/* global moment*/
angular
  .module('statWashByarea')
  .component('statWashByarea', {
    template: require('./stat-wash-byarea.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatWashByAreaController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'washbyarea';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.from_date = moment().startOf('month').format('YYYY-MM-DD');
        this.to_date = moment().endOf('month').format('YYYY-MM-DD');

        const promiseWashCountByArea = () => $resource(`${APIURL}/admin/stat/wash/counts/byarea`).get({ from_date: this.from_date, to_date: this.to_date }).$promise.then((data) => {
          this.washByAreasCount = data.washByAreasCount;
        });

        $scope.reload = () => {
          const promises = [promiseWashCountByArea()];
          Promise.all(promises).then(() => {});
        };

        $scope.onDatePick = () => {
          console.log('onDatePick');
          this.from_date = jQuery('#inputPickerFrom').val();
          this.to_date = jQuery('#inputPickerTo').val();
          $scope.reload();
        };

        $scope.reload();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-wash-byarea/stat-wash-byarea.component.js